<section class="producao-det-shell">
  <header class="producao-det-hero">
    <div>
      <h2 class="producao-det-title">Detalhes da Produção</h2>
      <p class="producao-det-subtitle">Acompanhe o histórico e avance os steps de produção.</p>
    </div>
    <div class="d-flex gap-2">
      <button *ngIf="podeAvancarStep()" class="btn btn-primary" (click)="abrirModalAvancarStep()">Avançar step</button>
      <button class="btn btn-outline-secondary" (click)="voltar()">Voltar</button>
    </div>
  </header>

  <!-- Régua de Produção -->
  <div class="card mb-4" *ngIf="statusPermitidos.length > 0">
    <div class="card-body">
      <h5 class="card-title mb-4">Acompanhamento da Produção</h5>

      <div class="producao-timeline">
        <div
          *ngFor="let status of statusPermitidos; let i = index; let isLast = last"
          class="producao-timeline-item">

          <!-- Linha conectora antes do ponto (exceto no primeiro) -->
          <div
            *ngIf="i > 0"
            class="producao-timeline-connector"
            [class.concluido]="isStatusConcluido(status.descricao) || isStatusAtual(status.descricao)">
          </div>

          <!-- Ponto do status -->
          <div
            class="producao-timeline-dot"
            [class.concluido]="isStatusConcluido(status.descricao)"
            [class.atual]="isStatusAtual(status.descricao)"
            [class.pendente]="!isStatusConcluido(status.descricao) && !isStatusAtual(status.descricao)">
            <span class="producao-timeline-check" *ngIf="isStatusConcluido(status.descricao)">✓</span>
          </div>

          <!-- Label abaixo do ponto -->
          <div
            class="producao-timeline-label"
            [class.atual]="isStatusAtual(status.descricao)"
            [class.concluido]="isStatusConcluido(status.descricao)">
            {{ status.descricao }}
          </div>

        </div>
      </div>

      <div class="mt-3" *ngIf="statusAtual">
        <span class="badge bg-primary fs-6">Status atual: {{ statusAtual }}</span>
      </div>
    </div>
  </div>

  <!-- Info do controle -->
  <div class="card mb-4">
    <div class="card-body">
      <strong>ID Controle:</strong> {{ idControle }}
    </div>
  </div>

  <!-- Tabela de histórico -->
  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Ordem</th>
          <th scope="col">Status</th>
          <th scope="col">Funcionário</th>
          <th scope="col">Data Início</th>
          <th scope="col">Data Fim</th>
          <th scope="col">Observação</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of historico">
          <td>{{ item.ordem }}</td>
          <td>{{ item.status }}</td>
          <td>{{ item.nomeCompletoFuncionario }}</td>
          <td>{{ item.dataInicio | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ item.dataFim | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ item.observacao }}</td>
          <td class="text-center">
            <button
              *ngIf="isUltimoStep(item)"
              type="button"
              class="btn btn-danger btn-sm"
              (click)="excluirStep(item.id)">
              Excluir step
            </button>
          </td>
        </tr>
        <tr *ngIf="historico.length === 0">
          <td colspan="7" class="text-center text-muted">Nenhum status encontrado para este item em produção.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal Avançar Step -->
  <div class="modal-overlay" *ngIf="modalAberto" (click)="fecharModalAvancarStep()">
    <div class="modal-content-custom" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Avançar Step da Produção</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="fecharModalAvancarStep()"></button>
      </div>

      <div class="mb-3">
        <label class="form-label">Funcionário (Setor PRODUCAO)</label>
        <select class="form-control" [(ngModel)]="formNovoStep.idFuncionario">
          <option [ngValue]="null">Selecione...</option>
          <option *ngFor="let f of funcionariosDisponiveis" [ngValue]="f.idFuncionario">
            {{ f.nome }} - {{ f.cargo }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Status</label>
        <select class="form-control" [(ngModel)]="formNovoStep.status">
          <option value="">Selecione...</option>
          <option *ngFor="let s of getStatusDisponiveisParaAvanco()" [value]="s.descricao">{{ s.descricao }}</option>
        </select>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label">Data início</label>
          <input type="date" class="form-control" [(ngModel)]="formNovoStep.dataInicio" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Data fim</label>
          <input type="date" class="form-control" [(ngModel)]="formNovoStep.dataFim" />
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Observação</label>
        <textarea class="form-control" rows="3" [(ngModel)]="formNovoStep.observacao"></textarea>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-secondary" (click)="fecharModalAvancarStep()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="salvandoStep" (click)="salvarNovoStep()">
          {{ salvandoStep ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
</section>
